import colors from '../../colors/colors';

export default function Label(props: any) {
    const { label, color, fontFamily } = props;
    return (
        <p style={{ fontSize: 15, marginBottom: 5, marginTop: 0 }} className={fontFamily ?? ""}>
            {label}<span style={{ color: color ?? colors.pink }}> *</span>
        </p>
    );
};